/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDlvryCompanyChainContainer containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export interface IDlvryCompanyChainContainerConfig extends Msdyn365.IModuleConfig {
    companyChainMatches?: ICompanyChainMatchesData[];
}

export const enum CompanyChainMatchesMatchType {
    exact = 'exact',
    startsWith = 'startsWith',
    endsWith = 'endsWith',
    contains = 'contains'
}

export interface ICompanyChainMatchesData {
    matchType: CompanyChainMatchesMatchType;
    matchValue: string;
    hideClassNamesIfMatch?: string;
}

export interface IDlvryCompanyChainContainerProps<T> extends Msdyn365.IModule<T> {
    config: IDlvryCompanyChainContainerConfig;
    slots: {
        content: React.ReactNode[];
    };
}
